export const LAYERURL = 'LAYERURL'